import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';

import { TrimsAdapter } from './dto/trims.adapter';
import { TrimsController } from './trims.controller';
import { Trims } from './trims.entity';
import { TrimsService } from './trims.service';

@Module({
  imports:[
    TypeOrmModule.forFeature([Trims]),
  ],
  controllers: [TrimsController],
  providers: [TrimsService,ApplicationExceptionHandler,TrimsAdapter]
})
export class TrimsModule {}
